import { render, staticRenderFns } from "./BankCardItem.vue?vue&type=template&id=3f5c2f83&scoped=true"
import script from "./BankCardItem.vue?vue&type=script&lang=js"
export * from "./BankCardItem.vue?vue&type=script&lang=js"
import style0 from "./BankCardItem.vue?vue&type=style&index=0&id=3f5c2f83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5c2f83",
  null
  
)

export default component.exports